import { Directive, Host, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { IActiveDate, NgPersianDatepickerComponent } from 'ng-persian-datepicker';
import { Subscription } from 'rxjs';

/**
 * Preserves the pre-v6 `[input]` API while using the Angular 16 datepicker.
 * The current application keeps its existing sibling input/template layout.
 */
@Directive({
  selector: 'ng-persian-datepicker[input]'
})
export class PersianDatepickerInputCompatDirective implements OnInit, OnDestroy {
  @Input() input!: HTMLInputElement;

  private readonly subscriptions = new Subscription();
  private readonly control = new FormControl();
  private readonly syncTypedValue = (): void => {
    this.control.setValue(this.input.value || null);
  };
  private readonly show = (event?: Event): void => {
    event?.stopPropagation();
    this.datepicker.uiIsVisible = true;
    this.datepicker.uiIsVisibleChange.emit(true);
  };

  constructor(@Host() private readonly datepicker: NgPersianDatepickerComponent) { }

  ngOnInit(): void {
    if (!this.input) {
      return;
    }

    this.input.addEventListener('focus', this.show);
    this.input.addEventListener('click', this.show);
    this.input.addEventListener('input', this.syncTypedValue);
    this.subscriptions.add(
      this.datepicker.dateOnSelect.subscribe(activeDate => this.writeSelectedDate(activeDate))
    );
    this.subscriptions.add(
      this.datepicker.dateOnInit.subscribe(activeDate => this.writeSelectedDate(activeDate))
    );
    this.control.setValue(this.input.value || null, { emitEvent: false });
    this.datepicker.setFormControl(this.control);
  }

  ngOnDestroy(): void {
    if (this.input) {
      this.input.removeEventListener('focus', this.show);
      this.input.removeEventListener('click', this.show);
      this.input.removeEventListener('input', this.syncTypedValue);
    }
    this.subscriptions.unsubscribe();
  }

  private writeSelectedDate(activeDate: IActiveDate): void {
    this.input.value = activeDate.shamsi;
    this.input.dispatchEvent(new Event('input', { bubbles: true }));
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
